<div class="landscape-mobile-overlay" [class.landscape-mode]="showOverlay()" data-crlat="landscapeOverlay">
    @if (showOverlay()) {
        <div class="app-logo"></div>
        <div class="phone-wrapper">
            <div class="phone-inner">
                <div class="i-phone">
                    <div class="camera"></div>
                    <div class="home-btn"></div>
                </div>
            </div>
            <div class="phone-inner phone-landscape">
                <div class="i-phone landscape">
                    <div class="camera"></div>
                    <div class="home-btn"></div>
                </div>
            </div>
        </div>
        <div class="phone-text" [i18n]="'app.phoneRotate'"></div>
    }
</div>
